import { Menu } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
import { useConsumeWeaveTheme } from '../../../theme/WeaveContext';
const StyledMenu = styled(Menu) `
	z-index: 9999;
`;
export default function OrgSwitcherMenu({ menuOpen, menuAnchorRef, closeMenu, children, }) {
    const { resolvedRoles, isWeaveTheme } = useConsumeWeaveTheme();
    const textColor = isWeaveTheme && resolvedRoles['colorScheme.text.default']
        ? resolvedRoles['colorScheme.text.default']
        : 'white';
    const backgroundColor = isWeaveTheme && resolvedRoles['menu.backgroundColor']
        ? resolvedRoles['menu.backgroundColor']
        : '#43575d';
    return (React.createElement(StyledMenu, { MenuListProps: {
            style: {
                borderRadius: 0,
                margin: 0,
                backgroundColor,
                color: textColor,
            },
        }, anchorOrigin: {
            vertical: 'top',
            horizontal: 'left',
        }, PaperProps: { style: { borderRadius: 0, margin: 0, top: 30 } }, anchorEl: menuOpen ? menuAnchorRef.current : null, open: menuOpen, onClose: closeMenu, id: 'alt-orgs-menu', keepMounted: true }, children));
}
